import messagesEn from '../i18n/en.json';

const enMessages = {
  ...messagesEn,
};

export default enMessages;
